/**
 * @param {Flickity} carousel
 */
export function cursorNavigation(carousel) {
	let clickAction;
	let viewportElement = carousel.viewport;
	let cursorElement = document.createElement('div');

	cursorElement.className = 'c-cursor';
	viewportElement.append(cursorElement);

	viewportElement.addEventListener('click', handleClick);
	viewportElement.addEventListener('mousemove', handleMouseMove);

	function hide() {
		clickAction = undefined;
		cursorElement.innerHTML = '';
		cursorElement.className = 'c-cursor';
	}

	function handleMouseMove(event) {
		let rect = viewportElement.getBoundingClientRect();

		function isMouseOutsideViewport(event) {
			return (
				event.clientX < rect.left ||
				event.clientX > rect.right ||
				event.clientY < rect.top ||
				event.clientY > rect.bottom
			);
		}

		if (isMouseOutsideViewport(event)) {
			hide();
			return;
		}

		if (event.clientX - rect.left <= 100) {
			clickAction = () => carousel.previous();

			cursorElement.innerHTML = createPrevArrow();
			cursorElement.className = 'c-cursor c-cursor--left is-visible';
		} else if (event.clientX >= rect.right - 100) {
			clickAction = () => carousel.next();

			cursorElement.innerHTML = createNextArrow();
			cursorElement.className = 'c-cursor c-cursor--right is-visible';
		} else {
			hide();
		}

		cursorElement.style.transform = `translate3d(${event.clientX - 20}px, ${event.clientY - 20}px, 0)`;
	}

	function handleClick(event) {
		if (clickAction === undefined) {
			return;
		}

		clickAction();
		event.preventDefault();
	}

	function destroy() {
		cursorElement.remove();
		viewportElement.removeEventListener('click', handleClick);
		viewportElement.removeEventListener('mousemove', handleMouseMove, false);
	}

	return { destroy };
}

export function createPrevArrow() {
	return createArrow('65 1 15 50 65 99');
}

export function createNextArrow() {
	return createArrow('35 99 85 50 35 1');
}

export function createArrow(path) {
	return (`
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
			<polyline fill="none" stroke-width="1px" stroke="currentColor" vector-effect="non-scaling-stroke" points="${path}"/>
		</svg>
	`);
}
